import {useAppSelector} from '@/hooks';

export function useGetCurrentPageIdGalleryTemplate(): string | undefined {
  return useAppSelector((state) => {
    const currentPageId = state.posterEditor.currentPageId;
    const page = state.posterEditor.posterObject?.pages?.pagesHashMap?.[currentPageId];
    return page?.galleryTemplateData?.posterId;
  });
}
